var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoActive18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5087_21672)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4.2C1.80817 4.2 1.45 4.55817 1.45 5V13C1.45 13.4418 1.80817 13.8 2.25 13.8H16.25C16.6918 13.8 17.05 13.4418 17.05 13V5C17.05 4.55817 16.6918 4.2 16.25 4.2H2.25ZM0.25 5C0.25 3.89543 1.14543 3 2.25 3H16.25C17.3546 3 18.25 3.89543 18.25 5V13C18.25 14.1046 17.3546 15 16.25 15H2.25C1.14543 15 0.25 14.1046 0.25 13V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 11.5003V6.26831H4.79575L6.42775 9.21231L6.96375 10.3243H6.99575C6.97442 10.0523 6.94775 9.76165 6.91575 9.45231C6.88908 9.13765 6.87575 8.83365 6.87575 8.54031V6.26831H7.76375V11.5003H6.81175L5.17975 8.55631L4.64375 7.44431H4.61175C4.63308 7.72165 4.65708 8.01231 4.68375 8.31631C4.71575 8.62031 4.73175 8.91898 4.73175 9.21231V11.5003H3.84375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52576 12.7803L10.3898 5.82031H11.0137L9.14976 12.7803H8.52576Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5954 8.71631L12.4114 9.35631H13.7474L13.5634 8.71631C13.4781 8.43898 13.3954 8.15365 13.3154 7.86031C13.2408 7.56698 13.1661 7.27631 13.0914 6.98831H13.0594C12.9848 7.28165 12.9101 7.57498 12.8354 7.86831C12.7608 8.15631 12.6808 8.43898 12.5954 8.71631ZM10.8434 11.5003L12.5474 6.26831H13.6354L15.3394 11.5003H14.3634L13.9554 10.0843H12.1954L11.7874 11.5003H10.8434Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5087_21672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActive18);
export default __webpack_public_path__ + "10f28076a0d7f38e739db92b38b36beb.svg";
export { ForwardRef as ReactComponent };